// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v1.181.2
//   protoc               v7.35.0
// source: ir/uid/base/base.proto

/* eslint-disable */
import Long from "long";
import _m0 from "protobufjs/minimal";
import { Timestamp } from "../../../google/protobuf/timestamp";
import { StringValue } from "../../../google/protobuf/wrappers";
import { Status } from "../../../google/rpc/status";

export const protobufPackage = "ir.uid.base";

export enum DataType {
  DATA_TYPE_TRANSIENT = 0,
  DATA_TYPE_PERMANENT = 1,
  UNRECOGNIZED = -1,
}

export function dataTypeFromJSON(object: any): DataType {
  switch (object) {
    case 0:
    case "DATA_TYPE_TRANSIENT":
      return DataType.DATA_TYPE_TRANSIENT;
    case 1:
    case "DATA_TYPE_PERMANENT":
      return DataType.DATA_TYPE_PERMANENT;
    case -1:
    case "UNRECOGNIZED":
    default:
      return DataType.UNRECOGNIZED;
  }
}

export function dataTypeToJSON(object: DataType): string {
  switch (object) {
    case DataType.DATA_TYPE_TRANSIENT:
      return "DATA_TYPE_TRANSIENT";
    case DataType.DATA_TYPE_PERMANENT:
      return "DATA_TYPE_PERMANENT";
    case DataType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum PairKey {
  PAIR_KEY_UNDEFINED = 0,
  PAIR_KEY_REFERENCE_IMAGE_LINK = 1,
  PAIR_KEY_COMPARE_IMAGE_LINK = 2,
  PAIR_KEY_VIDEO_LINK = 3,
  PAIR_KEY_SIGNATURE_LINK = 4,
  PAIR_KEY_NATIONAL_ID = 5,
  PAIR_KEY_BIRTH_DATE = 6,
  PAIR_KEY_MOBILE_NUMBER = 7,
  PAIR_KEY_ADDRESS = 8,
  PAIR_KEY_NATIONAL_ID_SERIAL = 9,
  PAIR_KEY_BUSINESS_ID = 10,
  PAIR_KEY_SESSION_ID = 11,
  PAIR_KEY_USER_ID = 12,
  PAIR_KEY_PROJECT_NAME = 13,
  PAIR_KEY_WORKFLOW_ID = 14,
  UNRECOGNIZED = -1,
}

export function pairKeyFromJSON(object: any): PairKey {
  switch (object) {
    case 0:
    case "PAIR_KEY_UNDEFINED":
      return PairKey.PAIR_KEY_UNDEFINED;
    case 1:
    case "PAIR_KEY_REFERENCE_IMAGE_LINK":
      return PairKey.PAIR_KEY_REFERENCE_IMAGE_LINK;
    case 2:
    case "PAIR_KEY_COMPARE_IMAGE_LINK":
      return PairKey.PAIR_KEY_COMPARE_IMAGE_LINK;
    case 3:
    case "PAIR_KEY_VIDEO_LINK":
      return PairKey.PAIR_KEY_VIDEO_LINK;
    case 4:
    case "PAIR_KEY_SIGNATURE_LINK":
      return PairKey.PAIR_KEY_SIGNATURE_LINK;
    case 5:
    case "PAIR_KEY_NATIONAL_ID":
      return PairKey.PAIR_KEY_NATIONAL_ID;
    case 6:
    case "PAIR_KEY_BIRTH_DATE":
      return PairKey.PAIR_KEY_BIRTH_DATE;
    case 7:
    case "PAIR_KEY_MOBILE_NUMBER":
      return PairKey.PAIR_KEY_MOBILE_NUMBER;
    case 8:
    case "PAIR_KEY_ADDRESS":
      return PairKey.PAIR_KEY_ADDRESS;
    case 9:
    case "PAIR_KEY_NATIONAL_ID_SERIAL":
      return PairKey.PAIR_KEY_NATIONAL_ID_SERIAL;
    case 10:
    case "PAIR_KEY_BUSINESS_ID":
      return PairKey.PAIR_KEY_BUSINESS_ID;
    case 11:
    case "PAIR_KEY_SESSION_ID":
      return PairKey.PAIR_KEY_SESSION_ID;
    case 12:
    case "PAIR_KEY_USER_ID":
      return PairKey.PAIR_KEY_USER_ID;
    case 13:
    case "PAIR_KEY_PROJECT_NAME":
      return PairKey.PAIR_KEY_PROJECT_NAME;
    case 14:
    case "PAIR_KEY_WORKFLOW_ID":
      return PairKey.PAIR_KEY_WORKFLOW_ID;
    case -1:
    case "UNRECOGNIZED":
    default:
      return PairKey.UNRECOGNIZED;
  }
}

export function pairKeyToJSON(object: PairKey): string {
  switch (object) {
    case PairKey.PAIR_KEY_UNDEFINED:
      return "PAIR_KEY_UNDEFINED";
    case PairKey.PAIR_KEY_REFERENCE_IMAGE_LINK:
      return "PAIR_KEY_REFERENCE_IMAGE_LINK";
    case PairKey.PAIR_KEY_COMPARE_IMAGE_LINK:
      return "PAIR_KEY_COMPARE_IMAGE_LINK";
    case PairKey.PAIR_KEY_VIDEO_LINK:
      return "PAIR_KEY_VIDEO_LINK";
    case PairKey.PAIR_KEY_SIGNATURE_LINK:
      return "PAIR_KEY_SIGNATURE_LINK";
    case PairKey.PAIR_KEY_NATIONAL_ID:
      return "PAIR_KEY_NATIONAL_ID";
    case PairKey.PAIR_KEY_BIRTH_DATE:
      return "PAIR_KEY_BIRTH_DATE";
    case PairKey.PAIR_KEY_MOBILE_NUMBER:
      return "PAIR_KEY_MOBILE_NUMBER";
    case PairKey.PAIR_KEY_ADDRESS:
      return "PAIR_KEY_ADDRESS";
    case PairKey.PAIR_KEY_NATIONAL_ID_SERIAL:
      return "PAIR_KEY_NATIONAL_ID_SERIAL";
    case PairKey.PAIR_KEY_BUSINESS_ID:
      return "PAIR_KEY_BUSINESS_ID";
    case PairKey.PAIR_KEY_SESSION_ID:
      return "PAIR_KEY_SESSION_ID";
    case PairKey.PAIR_KEY_USER_ID:
      return "PAIR_KEY_USER_ID";
    case PairKey.PAIR_KEY_PROJECT_NAME:
      return "PAIR_KEY_PROJECT_NAME";
    case PairKey.PAIR_KEY_WORKFLOW_ID:
      return "PAIR_KEY_WORKFLOW_ID";
    case PairKey.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum AppType {
  ANDROID = 0,
  WEB_ANDROID = 1,
  WEB_IOS = 2,
  UNRECOGNIZED = -1,
}

export function appTypeFromJSON(object: any): AppType {
  switch (object) {
    case 0:
    case "ANDROID":
      return AppType.ANDROID;
    case 1:
    case "WEB_ANDROID":
      return AppType.WEB_ANDROID;
    case 2:
    case "WEB_IOS":
      return AppType.WEB_IOS;
    case -1:
    case "UNRECOGNIZED":
    default:
      return AppType.UNRECOGNIZED;
  }
}

export function appTypeToJSON(object: AppType): string {
  switch (object) {
    case AppType.ANDROID:
      return "ANDROID";
    case AppType.WEB_ANDROID:
      return "WEB_ANDROID";
    case AppType.WEB_IOS:
      return "WEB_IOS";
    case AppType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum OtpTransferMethod {
  OTP_TRANSFER_METHOD_UNDEFINED = 0,
  OTP_TRANSFER_METHOD_SMS = 1,
  OTP_TRANSFER_METHOD_CALL = 2,
  OTP_TRANSFER_METHOD_APP = 3,
  OTP_TRANSFER_METHOD_EMAIL = 4,
  UNRECOGNIZED = -1,
}

export function otpTransferMethodFromJSON(object: any): OtpTransferMethod {
  switch (object) {
    case 0:
    case "OTP_TRANSFER_METHOD_UNDEFINED":
      return OtpTransferMethod.OTP_TRANSFER_METHOD_UNDEFINED;
    case 1:
    case "OTP_TRANSFER_METHOD_SMS":
      return OtpTransferMethod.OTP_TRANSFER_METHOD_SMS;
    case 2:
    case "OTP_TRANSFER_METHOD_CALL":
      return OtpTransferMethod.OTP_TRANSFER_METHOD_CALL;
    case 3:
    case "OTP_TRANSFER_METHOD_APP":
      return OtpTransferMethod.OTP_TRANSFER_METHOD_APP;
    case 4:
    case "OTP_TRANSFER_METHOD_EMAIL":
      return OtpTransferMethod.OTP_TRANSFER_METHOD_EMAIL;
    case -1:
    case "UNRECOGNIZED":
    default:
      return OtpTransferMethod.UNRECOGNIZED;
  }
}

export function otpTransferMethodToJSON(object: OtpTransferMethod): string {
  switch (object) {
    case OtpTransferMethod.OTP_TRANSFER_METHOD_UNDEFINED:
      return "OTP_TRANSFER_METHOD_UNDEFINED";
    case OtpTransferMethod.OTP_TRANSFER_METHOD_SMS:
      return "OTP_TRANSFER_METHOD_SMS";
    case OtpTransferMethod.OTP_TRANSFER_METHOD_CALL:
      return "OTP_TRANSFER_METHOD_CALL";
    case OtpTransferMethod.OTP_TRANSFER_METHOD_APP:
      return "OTP_TRANSFER_METHOD_APP";
    case OtpTransferMethod.OTP_TRANSFER_METHOD_EMAIL:
      return "OTP_TRANSFER_METHOD_EMAIL";
    case OtpTransferMethod.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum APIServiceType {
  API_SERVICE_TYPE_UNDEFINED = 0,
  API_SERVICE_TYPE_AUTHENTICATION_API = 1,
  UNRECOGNIZED = -1,
}

export function aPIServiceTypeFromJSON(object: any): APIServiceType {
  switch (object) {
    case 0:
    case "API_SERVICE_TYPE_UNDEFINED":
      return APIServiceType.API_SERVICE_TYPE_UNDEFINED;
    case 1:
    case "API_SERVICE_TYPE_AUTHENTICATION_API":
      return APIServiceType.API_SERVICE_TYPE_AUTHENTICATION_API;
    case -1:
    case "UNRECOGNIZED":
    default:
      return APIServiceType.UNRECOGNIZED;
  }
}

export function aPIServiceTypeToJSON(object: APIServiceType): string {
  switch (object) {
    case APIServiceType.API_SERVICE_TYPE_UNDEFINED:
      return "API_SERVICE_TYPE_UNDEFINED";
    case APIServiceType.API_SERVICE_TYPE_AUTHENTICATION_API:
      return "API_SERVICE_TYPE_AUTHENTICATION_API";
    case APIServiceType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum UserFlowAction {
  USER_FLOW_ACTION_UNDEFINED = 0,
  USER_FLOW_ACTION_CONTINUE = 1,
  USER_FLOW_ACTION_ABORT = 2,
  UNRECOGNIZED = -1,
}

export function userFlowActionFromJSON(object: any): UserFlowAction {
  switch (object) {
    case 0:
    case "USER_FLOW_ACTION_UNDEFINED":
      return UserFlowAction.USER_FLOW_ACTION_UNDEFINED;
    case 1:
    case "USER_FLOW_ACTION_CONTINUE":
      return UserFlowAction.USER_FLOW_ACTION_CONTINUE;
    case 2:
    case "USER_FLOW_ACTION_ABORT":
      return UserFlowAction.USER_FLOW_ACTION_ABORT;
    case -1:
    case "UNRECOGNIZED":
    default:
      return UserFlowAction.UNRECOGNIZED;
  }
}

export function userFlowActionToJSON(object: UserFlowAction): string {
  switch (object) {
    case UserFlowAction.USER_FLOW_ACTION_UNDEFINED:
      return "USER_FLOW_ACTION_UNDEFINED";
    case UserFlowAction.USER_FLOW_ACTION_CONTINUE:
      return "USER_FLOW_ACTION_CONTINUE";
    case UserFlowAction.USER_FLOW_ACTION_ABORT:
      return "USER_FLOW_ACTION_ABORT";
    case UserFlowAction.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum StepPages {
  UNDEFINED = 0,
  LANDING_PAGE = 1,
  ENTER_PHONE_NUMBER_PAGE = 2,
  HELP_SIGNATURE_DRAW_PAD_PAGE = 3,
  SIGNATURE_DRAW_PAD_PAGE = 4,
  VERIFY_PHONE_NUMBER_PAGE = 5,
  NATIONAL_CODE_PAGE = 6,
  SHEBA_NUMBER_PAGE = 7,
  LOCATION_INFORMATION_PAGE = 8,
  COMPLETE_USER_INFO_PAGE = 9,
  COMPLETE_IDENTIFY_INFORMATION_PAGE = 10,
  CONFIRM_INFORMATION_PAGE = 11,
  SUCCESS_PAYMENT_PAGE = 12,
  FIELD_PAYMENT_PAGE = 13,
  UNPAID_PAGE = 14,
  INFORMATION_CONFIRMED_PAGE = 15,
  INFORMATION_WAITING_PAGE = 16,
  NO_FACE_MATCHING_PAGE = 17,
  FACE_RECOGNITION_RECORDING_PAGE = 18,
  TAKE_PICTURE_NATIONAL_CARD_FRONT_PAGE = 19,
  TAKE_PICTURE_NATIONAL_CARD_BACK_PAGE = 20,
  TAKE_PICTURE_SIGNATURE_PAGE = 21,
  VIDEO_CONFIRMED_PAGE = 22,
  SHAHKAR_PAGE = 23,
  DIVAR_LANDING_PAGE = 24,
  OTP_PAGE = 25,
  USER_INFORMATION_PAGE = 26,
  USER_LOCATION_PAGE = 27,
  DIVAR_SUCCESS_PAYMENT_PAGE = 28,
  BANK_CARD_NUMBER_PAGE = 29,
  SUCCESS_AUTHENTICATION_PAGE = 30,
  SUCCESS_AUTHENTICATION_FLOW = 31,
  CAR_PLATE_NUMBER_PAGE = 32,
  CAR_INFO_PAGE = 33,
  BIRTH_DATE_PAGE = 34,
  POSTAL_CODE_PAGE = 35,
  LICENSE_PERSONALITY_PAGE = 36,
  LICENSE_PERSONALITY_INFO_PAGE = 37,
  NATIONAL_CARD_SERIAL_PAGE = 38,
  GET_BASIC_INFO_PAGE = 39,
  UNRECOGNIZED = -1,
}

export function stepPagesFromJSON(object: any): StepPages {
  switch (object) {
    case 0:
    case "UNDEFINED":
      return StepPages.UNDEFINED;
    case 1:
    case "LANDING_PAGE":
      return StepPages.LANDING_PAGE;
    case 2:
    case "ENTER_PHONE_NUMBER_PAGE":
      return StepPages.ENTER_PHONE_NUMBER_PAGE;
    case 3:
    case "HELP_SIGNATURE_DRAW_PAD_PAGE":
      return StepPages.HELP_SIGNATURE_DRAW_PAD_PAGE;
    case 4:
    case "SIGNATURE_DRAW_PAD_PAGE":
      return StepPages.SIGNATURE_DRAW_PAD_PAGE;
    case 5:
    case "VERIFY_PHONE_NUMBER_PAGE":
      return StepPages.VERIFY_PHONE_NUMBER_PAGE;
    case 6:
    case "NATIONAL_CODE_PAGE":
      return StepPages.NATIONAL_CODE_PAGE;
    case 7:
    case "SHEBA_NUMBER_PAGE":
      return StepPages.SHEBA_NUMBER_PAGE;
    case 8:
    case "LOCATION_INFORMATION_PAGE":
      return StepPages.LOCATION_INFORMATION_PAGE;
    case 9:
    case "COMPLETE_USER_INFO_PAGE":
      return StepPages.COMPLETE_USER_INFO_PAGE;
    case 10:
    case "COMPLETE_IDENTIFY_INFORMATION_PAGE":
      return StepPages.COMPLETE_IDENTIFY_INFORMATION_PAGE;
    case 11:
    case "CONFIRM_INFORMATION_PAGE":
      return StepPages.CONFIRM_INFORMATION_PAGE;
    case 12:
    case "SUCCESS_PAYMENT_PAGE":
      return StepPages.SUCCESS_PAYMENT_PAGE;
    case 13:
    case "FIELD_PAYMENT_PAGE":
      return StepPages.FIELD_PAYMENT_PAGE;
    case 14:
    case "UNPAID_PAGE":
      return StepPages.UNPAID_PAGE;
    case 15:
    case "INFORMATION_CONFIRMED_PAGE":
      return StepPages.INFORMATION_CONFIRMED_PAGE;
    case 16:
    case "INFORMATION_WAITING_PAGE":
      return StepPages.INFORMATION_WAITING_PAGE;
    case 17:
    case "NO_FACE_MATCHING_PAGE":
      return StepPages.NO_FACE_MATCHING_PAGE;
    case 18:
    case "FACE_RECOGNITION_RECORDING_PAGE":
      return StepPages.FACE_RECOGNITION_RECORDING_PAGE;
    case 19:
    case "TAKE_PICTURE_NATIONAL_CARD_FRONT_PAGE":
      return StepPages.TAKE_PICTURE_NATIONAL_CARD_FRONT_PAGE;
    case 20:
    case "TAKE_PICTURE_NATIONAL_CARD_BACK_PAGE":
      return StepPages.TAKE_PICTURE_NATIONAL_CARD_BACK_PAGE;
    case 21:
    case "TAKE_PICTURE_SIGNATURE_PAGE":
      return StepPages.TAKE_PICTURE_SIGNATURE_PAGE;
    case 22:
    case "VIDEO_CONFIRMED_PAGE":
      return StepPages.VIDEO_CONFIRMED_PAGE;
    case 23:
    case "SHAHKAR_PAGE":
      return StepPages.SHAHKAR_PAGE;
    case 24:
    case "DIVAR_LANDING_PAGE":
      return StepPages.DIVAR_LANDING_PAGE;
    case 25:
    case "OTP_PAGE":
      return StepPages.OTP_PAGE;
    case 26:
    case "USER_INFORMATION_PAGE":
      return StepPages.USER_INFORMATION_PAGE;
    case 27:
    case "USER_LOCATION_PAGE":
      return StepPages.USER_LOCATION_PAGE;
    case 28:
    case "DIVAR_SUCCESS_PAYMENT_PAGE":
      return StepPages.DIVAR_SUCCESS_PAYMENT_PAGE;
    case 29:
    case "BANK_CARD_NUMBER_PAGE":
      return StepPages.BANK_CARD_NUMBER_PAGE;
    case 30:
    case "SUCCESS_AUTHENTICATION_PAGE":
      return StepPages.SUCCESS_AUTHENTICATION_PAGE;
    case 31:
    case "SUCCESS_AUTHENTICATION_FLOW":
      return StepPages.SUCCESS_AUTHENTICATION_FLOW;
    case 32:
    case "CAR_PLATE_NUMBER_PAGE":
      return StepPages.CAR_PLATE_NUMBER_PAGE;
    case 33:
    case "CAR_INFO_PAGE":
      return StepPages.CAR_INFO_PAGE;
    case 34:
    case "BIRTH_DATE_PAGE":
      return StepPages.BIRTH_DATE_PAGE;
    case 35:
    case "POSTAL_CODE_PAGE":
      return StepPages.POSTAL_CODE_PAGE;
    case 36:
    case "LICENSE_PERSONALITY_PAGE":
      return StepPages.LICENSE_PERSONALITY_PAGE;
    case 37:
    case "LICENSE_PERSONALITY_INFO_PAGE":
      return StepPages.LICENSE_PERSONALITY_INFO_PAGE;
    case 38:
    case "NATIONAL_CARD_SERIAL_PAGE":
      return StepPages.NATIONAL_CARD_SERIAL_PAGE;
    case 39:
    case "GET_BASIC_INFO_PAGE":
      return StepPages.GET_BASIC_INFO_PAGE;
    case -1:
    case "UNRECOGNIZED":
    default:
      return StepPages.UNRECOGNIZED;
  }
}

export function stepPagesToJSON(object: StepPages): string {
  switch (object) {
    case StepPages.UNDEFINED:
      return "UNDEFINED";
    case StepPages.LANDING_PAGE:
      return "LANDING_PAGE";
    case StepPages.ENTER_PHONE_NUMBER_PAGE:
      return "ENTER_PHONE_NUMBER_PAGE";
    case StepPages.HELP_SIGNATURE_DRAW_PAD_PAGE:
      return "HELP_SIGNATURE_DRAW_PAD_PAGE";
    case StepPages.SIGNATURE_DRAW_PAD_PAGE:
      return "SIGNATURE_DRAW_PAD_PAGE";
    case StepPages.VERIFY_PHONE_NUMBER_PAGE:
      return "VERIFY_PHONE_NUMBER_PAGE";
    case StepPages.NATIONAL_CODE_PAGE:
      return "NATIONAL_CODE_PAGE";
    case StepPages.SHEBA_NUMBER_PAGE:
      return "SHEBA_NUMBER_PAGE";
    case StepPages.LOCATION_INFORMATION_PAGE:
      return "LOCATION_INFORMATION_PAGE";
    case StepPages.COMPLETE_USER_INFO_PAGE:
      return "COMPLETE_USER_INFO_PAGE";
    case StepPages.COMPLETE_IDENTIFY_INFORMATION_PAGE:
      return "COMPLETE_IDENTIFY_INFORMATION_PAGE";
    case StepPages.CONFIRM_INFORMATION_PAGE:
      return "CONFIRM_INFORMATION_PAGE";
    case StepPages.SUCCESS_PAYMENT_PAGE:
      return "SUCCESS_PAYMENT_PAGE";
    case StepPages.FIELD_PAYMENT_PAGE:
      return "FIELD_PAYMENT_PAGE";
    case StepPages.UNPAID_PAGE:
      return "UNPAID_PAGE";
    case StepPages.INFORMATION_CONFIRMED_PAGE:
      return "INFORMATION_CONFIRMED_PAGE";
    case StepPages.INFORMATION_WAITING_PAGE:
      return "INFORMATION_WAITING_PAGE";
    case StepPages.NO_FACE_MATCHING_PAGE:
      return "NO_FACE_MATCHING_PAGE";
    case StepPages.FACE_RECOGNITION_RECORDING_PAGE:
      return "FACE_RECOGNITION_RECORDING_PAGE";
    case StepPages.TAKE_PICTURE_NATIONAL_CARD_FRONT_PAGE:
      return "TAKE_PICTURE_NATIONAL_CARD_FRONT_PAGE";
    case StepPages.TAKE_PICTURE_NATIONAL_CARD_BACK_PAGE:
      return "TAKE_PICTURE_NATIONAL_CARD_BACK_PAGE";
    case StepPages.TAKE_PICTURE_SIGNATURE_PAGE:
      return "TAKE_PICTURE_SIGNATURE_PAGE";
    case StepPages.VIDEO_CONFIRMED_PAGE:
      return "VIDEO_CONFIRMED_PAGE";
    case StepPages.SHAHKAR_PAGE:
      return "SHAHKAR_PAGE";
    case StepPages.DIVAR_LANDING_PAGE:
      return "DIVAR_LANDING_PAGE";
    case StepPages.OTP_PAGE:
      return "OTP_PAGE";
    case StepPages.USER_INFORMATION_PAGE:
      return "USER_INFORMATION_PAGE";
    case StepPages.USER_LOCATION_PAGE:
      return "USER_LOCATION_PAGE";
    case StepPages.DIVAR_SUCCESS_PAYMENT_PAGE:
      return "DIVAR_SUCCESS_PAYMENT_PAGE";
    case StepPages.BANK_CARD_NUMBER_PAGE:
      return "BANK_CARD_NUMBER_PAGE";
    case StepPages.SUCCESS_AUTHENTICATION_PAGE:
      return "SUCCESS_AUTHENTICATION_PAGE";
    case StepPages.SUCCESS_AUTHENTICATION_FLOW:
      return "SUCCESS_AUTHENTICATION_FLOW";
    case StepPages.CAR_PLATE_NUMBER_PAGE:
      return "CAR_PLATE_NUMBER_PAGE";
    case StepPages.CAR_INFO_PAGE:
      return "CAR_INFO_PAGE";
    case StepPages.BIRTH_DATE_PAGE:
      return "BIRTH_DATE_PAGE";
    case StepPages.POSTAL_CODE_PAGE:
      return "POSTAL_CODE_PAGE";
    case StepPages.LICENSE_PERSONALITY_PAGE:
      return "LICENSE_PERSONALITY_PAGE";
    case StepPages.LICENSE_PERSONALITY_INFO_PAGE:
      return "LICENSE_PERSONALITY_INFO_PAGE";
    case StepPages.NATIONAL_CARD_SERIAL_PAGE:
      return "NATIONAL_CARD_SERIAL_PAGE";
    case StepPages.GET_BASIC_INFO_PAGE:
      return "GET_BASIC_INFO_PAGE";
    case StepPages.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum ResultStatus {
  RESULT_STATUS_UNDEFINED = 0,
  RESULT_STATUS_SUCCESS = 1,
  RESULT_STATUS_CAMERA_NOT_SUPPORTED = 2,
  RESULT_STATUS_PERMISSIONS_NOT_GRANTED = 3,
  RESULT_STATUS_UNKNOWN_ERROR = 4,
  RESULT_STATUS_INVALID_PARAMETERS = 5,
  RESULT_STATUS_PAYMENT_FAILED = 6,
  RESULT_STATUS_USER_CANCELED_PROCESS = 7,
  UNRECOGNIZED = -1,
}

export function resultStatusFromJSON(object: any): ResultStatus {
  switch (object) {
    case 0:
    case "RESULT_STATUS_UNDEFINED":
      return ResultStatus.RESULT_STATUS_UNDEFINED;
    case 1:
    case "RESULT_STATUS_SUCCESS":
      return ResultStatus.RESULT_STATUS_SUCCESS;
    case 2:
    case "RESULT_STATUS_CAMERA_NOT_SUPPORTED":
      return ResultStatus.RESULT_STATUS_CAMERA_NOT_SUPPORTED;
    case 3:
    case "RESULT_STATUS_PERMISSIONS_NOT_GRANTED":
      return ResultStatus.RESULT_STATUS_PERMISSIONS_NOT_GRANTED;
    case 4:
    case "RESULT_STATUS_UNKNOWN_ERROR":
      return ResultStatus.RESULT_STATUS_UNKNOWN_ERROR;
    case 5:
    case "RESULT_STATUS_INVALID_PARAMETERS":
      return ResultStatus.RESULT_STATUS_INVALID_PARAMETERS;
    case 6:
    case "RESULT_STATUS_PAYMENT_FAILED":
      return ResultStatus.RESULT_STATUS_PAYMENT_FAILED;
    case 7:
    case "RESULT_STATUS_USER_CANCELED_PROCESS":
      return ResultStatus.RESULT_STATUS_USER_CANCELED_PROCESS;
    case -1:
    case "UNRECOGNIZED":
    default:
      return ResultStatus.UNRECOGNIZED;
  }
}

export function resultStatusToJSON(object: ResultStatus): string {
  switch (object) {
    case ResultStatus.RESULT_STATUS_UNDEFINED:
      return "RESULT_STATUS_UNDEFINED";
    case ResultStatus.RESULT_STATUS_SUCCESS:
      return "RESULT_STATUS_SUCCESS";
    case ResultStatus.RESULT_STATUS_CAMERA_NOT_SUPPORTED:
      return "RESULT_STATUS_CAMERA_NOT_SUPPORTED";
    case ResultStatus.RESULT_STATUS_PERMISSIONS_NOT_GRANTED:
      return "RESULT_STATUS_PERMISSIONS_NOT_GRANTED";
    case ResultStatus.RESULT_STATUS_UNKNOWN_ERROR:
      return "RESULT_STATUS_UNKNOWN_ERROR";
    case ResultStatus.RESULT_STATUS_INVALID_PARAMETERS:
      return "RESULT_STATUS_INVALID_PARAMETERS";
    case ResultStatus.RESULT_STATUS_PAYMENT_FAILED:
      return "RESULT_STATUS_PAYMENT_FAILED";
    case ResultStatus.RESULT_STATUS_USER_CANCELED_PROCESS:
      return "RESULT_STATUS_USER_CANCELED_PROCESS";
    case ResultStatus.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface AbstractValue {
  stringValue?: string | undefined;
  booleanValue?: boolean | undefined;
  binaryValue?: Uint8Array | undefined;
  integerValue?: number | undefined;
  base64Value?: string | undefined;
  doubleValue?: number | undefined;
  type: DataType;
}

export interface Pair {
  key: string;
  value: AbstractValue | undefined;
}

export interface KeyLimitedPair {
  key: PairKey;
  value: AbstractValue | undefined;
}

export interface BasicUserPassCredential {
  userName: string;
  password: string;
}

export interface OauthToken {
  token: string;
}

export interface Credential {
  userPass?: BasicUserPassCredential | undefined;
  oauthToken?: OauthToken | undefined;
}

export interface Version {
  /** Major component of application version. */
  major: number;
  /** Minor component of application version. */
  minor: number;
  /** Patch component of application version. */
  patch: number;
  /** Build number component of application version. */
  build: number;
}

export interface App {
  /**
   * *REQUIRED** Signature hash of client's executable in SHA2/256 form.
   *
   * - Important: Server MUST check this value against whitelisted hashes and reject login request if it is not enlisted.
   */
  hash: Uint8Array;
  /**
   * For Android devices, use methods [described here](https://mobile-security.gitbook.io/mobile-security-testing-guide/android-testing-guide/0x05j-testing-resiliency-against-reverse-engineering#testing-anti-debugging-detection-mstg-resilience-2).
   * For iOS devices, use methods [described here](https://mobile-security.gitbook.io/mobile-security-testing-guide/ios-testing-guide/0x06j-testing-resiliency-against-reverse-engineering#testing-anti-debugging-detection-mstg-resilience-2).
   * For PWA devices, use method [described in this Stackoverflow answer](https://stackoverflow.com/a/48287643/5304286).
   */
  debuggerAttached: boolean;
}

export interface AppInfo {
  /** *REQUIRED** Client's version. */
  version:
    | Version
    | undefined;
  /**
   * For Android devices, it contains package ID of application which installed the app.
   * For iOS devices, it contains the store name which it is published.
   * For PWA devices, It contains `Referer` http header, if there is any.
   *
   * - Note: Empty string means no installation source can be determined.
   */
  installationSource: string;
  /** Bundle ID or Package name of app. */
  bundleId: string;
  appType: AppType;
  appSignature: Uint8Array;
  stepToken: string;
  userSessionToken: Uint8Array;
}

export interface OtpTarget {
  transferMethod: OtpTransferMethod;
  phoneNumber?: string | undefined;
  emailAddress?: string | undefined;
  appId?: string | undefined;
}

export interface ClientInformation {
}

export interface Page {
  page: number;
  pageSize: number;
  /** this field is filled by server */
  totalSize: number;
}

export interface TimeContext {
  clientTime: Date | undefined;
  expectedArrivalTime: Date | undefined;
  abortTime: Date | undefined;
}

export interface RequestHeader {
  requestId: string;
  RequestHmac: Uint8Array;
  timeContext: TimeContext | undefined;
}

export interface RequestContext {
  requestHeader: RequestHeader | undefined;
  appInfo?: AppInfo | undefined;
  apiInfo?: APIInfo | undefined;
  panelInfo?: PanelInfo | undefined;
  pwaInfo?: PwaInfo | undefined;
}

/** object that used by pwa to send information to identify the pwa */
export interface PwaInfo {
  businessId: string;
  /** session that used to track landing page touches in pwa */
  pwaSessionId: string | undefined;
  stepToken: string;
}

export interface PanelInfo {
  panelName: string;
  panelId: string;
  sessionToken: string;
}

export interface APIInfo {
  businessId: string;
  businessToken: string;
  serviceType: APIServiceType;
  userSessionToken: string;
  stepToken: string;
}

export interface ResponseContext {
  /**
   * Contains response code, localized message and associated data.
   *
   * See [Errors guide](https://cloud.google.com/apis/design/errors) for detailed description and equivalent http codes.
   *
   * See [this markdown](https://github.com/grpc/grpc/blob/master/doc/statuscodes.md) for technical details.
   */
  status:
    | Status
    | undefined;
  /**
   * A unique UUID generated by client and sent to server in request.
   *
   * - Important: Server may block flooding requests with similar request IDs.
   */
  requestId: string;
  /** A unique UUID generated by server for incoming request. */
  correlationId: string;
  nextStep: NextStepInfo[];
  /** todo: think of a way to also specify the next endpoint as well */
  nextStepPage: StepPages;
  /** Custom key/value data that server may send to client. */
  custom: { [key: string]: string };
}

export interface ResponseContext_CustomEntry {
  key: string;
  value: string;
}

export interface NextStepInfo {
  userAction: UserFlowAction;
  navigationURI: string;
  nextStepToken: string;
  userSessionId: string;
  nextStepPage: StepPages;
}

export interface BareResponse {
  responseContext: ResponseContext | undefined;
}

export interface ExceptionInfo {
  exceptionMassage: string;
  exceptionType: string;
}

function createBaseAbstractValue(): AbstractValue {
  return {
    stringValue: undefined,
    booleanValue: undefined,
    binaryValue: undefined,
    integerValue: undefined,
    base64Value: undefined,
    doubleValue: undefined,
    type: 0,
  };
}

export const AbstractValue = {
  encode(message: AbstractValue, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.stringValue !== undefined) {
      writer.uint32(10).string(message.stringValue);
    }
    if (message.booleanValue !== undefined) {
      writer.uint32(16).bool(message.booleanValue);
    }
    if (message.binaryValue !== undefined) {
      writer.uint32(26).bytes(message.binaryValue);
    }
    if (message.integerValue !== undefined) {
      writer.uint32(32).int64(message.integerValue);
    }
    if (message.base64Value !== undefined) {
      writer.uint32(42).string(message.base64Value);
    }
    if (message.doubleValue !== undefined) {
      writer.uint32(49).double(message.doubleValue);
    }
    if (message.type !== 0) {
      writer.uint32(184).int32(message.type);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): AbstractValue {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAbstractValue();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.stringValue = reader.string();
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.booleanValue = reader.bool();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.binaryValue = reader.bytes();
          continue;
        case 4:
          if (tag !== 32) {
            break;
          }

          message.integerValue = longToNumber(reader.int64() as Long);
          continue;
        case 5:
          if (tag !== 42) {
            break;
          }

          message.base64Value = reader.string();
          continue;
        case 6:
          if (tag !== 49) {
            break;
          }

          message.doubleValue = reader.double();
          continue;
        case 23:
          if (tag !== 184) {
            break;
          }

          message.type = reader.int32() as any;
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AbstractValue {
    return {
      stringValue: isSet(object.stringValue) ? globalThis.String(object.stringValue) : undefined,
      booleanValue: isSet(object.booleanValue) ? globalThis.Boolean(object.booleanValue) : undefined,
      binaryValue: isSet(object.binaryValue) ? bytesFromBase64(object.binaryValue) : undefined,
      integerValue: isSet(object.integerValue) ? globalThis.Number(object.integerValue) : undefined,
      base64Value: isSet(object.base64Value) ? globalThis.String(object.base64Value) : undefined,
      doubleValue: isSet(object.doubleValue) ? globalThis.Number(object.doubleValue) : undefined,
      type: isSet(object.type) ? dataTypeFromJSON(object.type) : 0,
    };
  },

  toJSON(message: AbstractValue): unknown {
    const obj: any = {};
    if (message.stringValue !== undefined) {
      obj.stringValue = message.stringValue;
    }
    if (message.booleanValue !== undefined) {
      obj.booleanValue = message.booleanValue;
    }
    if (message.binaryValue !== undefined) {
      obj.binaryValue = base64FromBytes(message.binaryValue);
    }
    if (message.integerValue !== undefined) {
      obj.integerValue = Math.round(message.integerValue);
    }
    if (message.base64Value !== undefined) {
      obj.base64Value = message.base64Value;
    }
    if (message.doubleValue !== undefined) {
      obj.doubleValue = message.doubleValue;
    }
    if (message.type !== 0) {
      obj.type = dataTypeToJSON(message.type);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AbstractValue>, I>>(base?: I): AbstractValue {
    return AbstractValue.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AbstractValue>, I>>(object: I): AbstractValue {
    const message = createBaseAbstractValue();
    message.stringValue = object.stringValue ?? undefined;
    message.booleanValue = object.booleanValue ?? undefined;
    message.binaryValue = object.binaryValue ?? undefined;
    message.integerValue = object.integerValue ?? undefined;
    message.base64Value = object.base64Value ?? undefined;
    message.doubleValue = object.doubleValue ?? undefined;
    message.type = object.type ?? 0;
    return message;
  },
};

function createBasePair(): Pair {
  return { key: "", value: undefined };
}

export const Pair = {
  encode(message: Pair, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== undefined) {
      AbstractValue.encode(message.value, writer.uint32(18).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): Pair {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePair();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.value = AbstractValue.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Pair {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? AbstractValue.fromJSON(object.value) : undefined,
    };
  },

  toJSON(message: Pair): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== undefined) {
      obj.value = AbstractValue.toJSON(message.value);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Pair>, I>>(base?: I): Pair {
    return Pair.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Pair>, I>>(object: I): Pair {
    const message = createBasePair();
    message.key = object.key ?? "";
    message.value = (object.value !== undefined && object.value !== null)
      ? AbstractValue.fromPartial(object.value)
      : undefined;
    return message;
  },
};

function createBaseKeyLimitedPair(): KeyLimitedPair {
  return { key: 0, value: undefined };
}

export const KeyLimitedPair = {
  encode(message: KeyLimitedPair, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.key !== 0) {
      writer.uint32(8).int32(message.key);
    }
    if (message.value !== undefined) {
      AbstractValue.encode(message.value, writer.uint32(18).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): KeyLimitedPair {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseKeyLimitedPair();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.key = reader.int32() as any;
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.value = AbstractValue.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): KeyLimitedPair {
    return {
      key: isSet(object.key) ? pairKeyFromJSON(object.key) : 0,
      value: isSet(object.value) ? AbstractValue.fromJSON(object.value) : undefined,
    };
  },

  toJSON(message: KeyLimitedPair): unknown {
    const obj: any = {};
    if (message.key !== 0) {
      obj.key = pairKeyToJSON(message.key);
    }
    if (message.value !== undefined) {
      obj.value = AbstractValue.toJSON(message.value);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<KeyLimitedPair>, I>>(base?: I): KeyLimitedPair {
    return KeyLimitedPair.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<KeyLimitedPair>, I>>(object: I): KeyLimitedPair {
    const message = createBaseKeyLimitedPair();
    message.key = object.key ?? 0;
    message.value = (object.value !== undefined && object.value !== null)
      ? AbstractValue.fromPartial(object.value)
      : undefined;
    return message;
  },
};

function createBaseBasicUserPassCredential(): BasicUserPassCredential {
  return { userName: "", password: "" };
}

export const BasicUserPassCredential = {
  encode(message: BasicUserPassCredential, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.userName !== "") {
      writer.uint32(10).string(message.userName);
    }
    if (message.password !== "") {
      writer.uint32(18).string(message.password);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): BasicUserPassCredential {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBasicUserPassCredential();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.userName = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.password = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): BasicUserPassCredential {
    return {
      userName: isSet(object.userName) ? globalThis.String(object.userName) : "",
      password: isSet(object.password) ? globalThis.String(object.password) : "",
    };
  },

  toJSON(message: BasicUserPassCredential): unknown {
    const obj: any = {};
    if (message.userName !== "") {
      obj.userName = message.userName;
    }
    if (message.password !== "") {
      obj.password = message.password;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<BasicUserPassCredential>, I>>(base?: I): BasicUserPassCredential {
    return BasicUserPassCredential.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<BasicUserPassCredential>, I>>(object: I): BasicUserPassCredential {
    const message = createBaseBasicUserPassCredential();
    message.userName = object.userName ?? "";
    message.password = object.password ?? "";
    return message;
  },
};

function createBaseOauthToken(): OauthToken {
  return { token: "" };
}

export const OauthToken = {
  encode(message: OauthToken, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.token !== "") {
      writer.uint32(10).string(message.token);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): OauthToken {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseOauthToken();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.token = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): OauthToken {
    return { token: isSet(object.token) ? globalThis.String(object.token) : "" };
  },

  toJSON(message: OauthToken): unknown {
    const obj: any = {};
    if (message.token !== "") {
      obj.token = message.token;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<OauthToken>, I>>(base?: I): OauthToken {
    return OauthToken.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<OauthToken>, I>>(object: I): OauthToken {
    const message = createBaseOauthToken();
    message.token = object.token ?? "";
    return message;
  },
};

function createBaseCredential(): Credential {
  return { userPass: undefined, oauthToken: undefined };
}

export const Credential = {
  encode(message: Credential, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.userPass !== undefined) {
      BasicUserPassCredential.encode(message.userPass, writer.uint32(10).fork()).ldelim();
    }
    if (message.oauthToken !== undefined) {
      OauthToken.encode(message.oauthToken, writer.uint32(18).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): Credential {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCredential();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.userPass = BasicUserPassCredential.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.oauthToken = OauthToken.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Credential {
    return {
      userPass: isSet(object.userPass) ? BasicUserPassCredential.fromJSON(object.userPass) : undefined,
      oauthToken: isSet(object.oauthToken) ? OauthToken.fromJSON(object.oauthToken) : undefined,
    };
  },

  toJSON(message: Credential): unknown {
    const obj: any = {};
    if (message.userPass !== undefined) {
      obj.userPass = BasicUserPassCredential.toJSON(message.userPass);
    }
    if (message.oauthToken !== undefined) {
      obj.oauthToken = OauthToken.toJSON(message.oauthToken);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Credential>, I>>(base?: I): Credential {
    return Credential.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Credential>, I>>(object: I): Credential {
    const message = createBaseCredential();
    message.userPass = (object.userPass !== undefined && object.userPass !== null)
      ? BasicUserPassCredential.fromPartial(object.userPass)
      : undefined;
    message.oauthToken = (object.oauthToken !== undefined && object.oauthToken !== null)
      ? OauthToken.fromPartial(object.oauthToken)
      : undefined;
    return message;
  },
};

function createBaseVersion(): Version {
  return { major: 0, minor: 0, patch: 0, build: 0 };
}

export const Version = {
  encode(message: Version, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.major !== 0) {
      writer.uint32(8).int32(message.major);
    }
    if (message.minor !== 0) {
      writer.uint32(16).int32(message.minor);
    }
    if (message.patch !== 0) {
      writer.uint32(24).int32(message.patch);
    }
    if (message.build !== 0) {
      writer.uint32(32).int32(message.build);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): Version {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseVersion();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.major = reader.int32();
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.minor = reader.int32();
          continue;
        case 3:
          if (tag !== 24) {
            break;
          }

          message.patch = reader.int32();
          continue;
        case 4:
          if (tag !== 32) {
            break;
          }

          message.build = reader.int32();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Version {
    return {
      major: isSet(object.major) ? globalThis.Number(object.major) : 0,
      minor: isSet(object.minor) ? globalThis.Number(object.minor) : 0,
      patch: isSet(object.patch) ? globalThis.Number(object.patch) : 0,
      build: isSet(object.build) ? globalThis.Number(object.build) : 0,
    };
  },

  toJSON(message: Version): unknown {
    const obj: any = {};
    if (message.major !== 0) {
      obj.major = Math.round(message.major);
    }
    if (message.minor !== 0) {
      obj.minor = Math.round(message.minor);
    }
    if (message.patch !== 0) {
      obj.patch = Math.round(message.patch);
    }
    if (message.build !== 0) {
      obj.build = Math.round(message.build);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Version>, I>>(base?: I): Version {
    return Version.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Version>, I>>(object: I): Version {
    const message = createBaseVersion();
    message.major = object.major ?? 0;
    message.minor = object.minor ?? 0;
    message.patch = object.patch ?? 0;
    message.build = object.build ?? 0;
    return message;
  },
};

function createBaseApp(): App {
  return { hash: new Uint8Array(0), debuggerAttached: false };
}

export const App = {
  encode(message: App, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.hash.length !== 0) {
      writer.uint32(18).bytes(message.hash);
    }
    if (message.debuggerAttached !== false) {
      writer.uint32(80).bool(message.debuggerAttached);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): App {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseApp();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2:
          if (tag !== 18) {
            break;
          }

          message.hash = reader.bytes();
          continue;
        case 10:
          if (tag !== 80) {
            break;
          }

          message.debuggerAttached = reader.bool();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): App {
    return {
      hash: isSet(object.hash) ? bytesFromBase64(object.hash) : new Uint8Array(0),
      debuggerAttached: isSet(object.debuggerAttached) ? globalThis.Boolean(object.debuggerAttached) : false,
    };
  },

  toJSON(message: App): unknown {
    const obj: any = {};
    if (message.hash.length !== 0) {
      obj.hash = base64FromBytes(message.hash);
    }
    if (message.debuggerAttached !== false) {
      obj.debuggerAttached = message.debuggerAttached;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<App>, I>>(base?: I): App {
    return App.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<App>, I>>(object: I): App {
    const message = createBaseApp();
    message.hash = object.hash ?? new Uint8Array(0);
    message.debuggerAttached = object.debuggerAttached ?? false;
    return message;
  },
};

function createBaseAppInfo(): AppInfo {
  return {
    version: undefined,
    installationSource: "",
    bundleId: "",
    appType: 0,
    appSignature: new Uint8Array(0),
    stepToken: "",
    userSessionToken: new Uint8Array(0),
  };
}

export const AppInfo = {
  encode(message: AppInfo, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.version !== undefined) {
      Version.encode(message.version, writer.uint32(10).fork()).ldelim();
    }
    if (message.installationSource !== "") {
      writer.uint32(18).string(message.installationSource);
    }
    if (message.bundleId !== "") {
      writer.uint32(26).string(message.bundleId);
    }
    if (message.appType !== 0) {
      writer.uint32(32).int32(message.appType);
    }
    if (message.appSignature.length !== 0) {
      writer.uint32(42).bytes(message.appSignature);
    }
    if (message.stepToken !== "") {
      writer.uint32(50).string(message.stepToken);
    }
    if (message.userSessionToken.length !== 0) {
      writer.uint32(58).bytes(message.userSessionToken);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): AppInfo {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAppInfo();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.version = Version.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.installationSource = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.bundleId = reader.string();
          continue;
        case 4:
          if (tag !== 32) {
            break;
          }

          message.appType = reader.int32() as any;
          continue;
        case 5:
          if (tag !== 42) {
            break;
          }

          message.appSignature = reader.bytes();
          continue;
        case 6:
          if (tag !== 50) {
            break;
          }

          message.stepToken = reader.string();
          continue;
        case 7:
          if (tag !== 58) {
            break;
          }

          message.userSessionToken = reader.bytes();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AppInfo {
    return {
      version: isSet(object.version) ? Version.fromJSON(object.version) : undefined,
      installationSource: isSet(object.installationSource) ? globalThis.String(object.installationSource) : "",
      bundleId: isSet(object.bundleId) ? globalThis.String(object.bundleId) : "",
      appType: isSet(object.appType) ? appTypeFromJSON(object.appType) : 0,
      appSignature: isSet(object.appSignature) ? bytesFromBase64(object.appSignature) : new Uint8Array(0),
      stepToken: isSet(object.stepToken) ? globalThis.String(object.stepToken) : "",
      userSessionToken: isSet(object.userSessionToken) ? bytesFromBase64(object.userSessionToken) : new Uint8Array(0),
    };
  },

  toJSON(message: AppInfo): unknown {
    const obj: any = {};
    if (message.version !== undefined) {
      obj.version = Version.toJSON(message.version);
    }
    if (message.installationSource !== "") {
      obj.installationSource = message.installationSource;
    }
    if (message.bundleId !== "") {
      obj.bundleId = message.bundleId;
    }
    if (message.appType !== 0) {
      obj.appType = appTypeToJSON(message.appType);
    }
    if (message.appSignature.length !== 0) {
      obj.appSignature = base64FromBytes(message.appSignature);
    }
    if (message.stepToken !== "") {
      obj.stepToken = message.stepToken;
    }
    if (message.userSessionToken.length !== 0) {
      obj.userSessionToken = base64FromBytes(message.userSessionToken);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AppInfo>, I>>(base?: I): AppInfo {
    return AppInfo.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AppInfo>, I>>(object: I): AppInfo {
    const message = createBaseAppInfo();
    message.version = (object.version !== undefined && object.version !== null)
      ? Version.fromPartial(object.version)
      : undefined;
    message.installationSource = object.installationSource ?? "";
    message.bundleId = object.bundleId ?? "";
    message.appType = object.appType ?? 0;
    message.appSignature = object.appSignature ?? new Uint8Array(0);
    message.stepToken = object.stepToken ?? "";
    message.userSessionToken = object.userSessionToken ?? new Uint8Array(0);
    return message;
  },
};

function createBaseOtpTarget(): OtpTarget {
  return { transferMethod: 0, phoneNumber: undefined, emailAddress: undefined, appId: undefined };
}

export const OtpTarget = {
  encode(message: OtpTarget, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.transferMethod !== 0) {
      writer.uint32(8).int32(message.transferMethod);
    }
    if (message.phoneNumber !== undefined) {
      writer.uint32(18).string(message.phoneNumber);
    }
    if (message.emailAddress !== undefined) {
      writer.uint32(26).string(message.emailAddress);
    }
    if (message.appId !== undefined) {
      writer.uint32(34).string(message.appId);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): OtpTarget {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseOtpTarget();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.transferMethod = reader.int32() as any;
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.phoneNumber = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.emailAddress = reader.string();
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.appId = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): OtpTarget {
    return {
      transferMethod: isSet(object.transferMethod) ? otpTransferMethodFromJSON(object.transferMethod) : 0,
      phoneNumber: isSet(object.phoneNumber) ? globalThis.String(object.phoneNumber) : undefined,
      emailAddress: isSet(object.emailAddress) ? globalThis.String(object.emailAddress) : undefined,
      appId: isSet(object.appId) ? globalThis.String(object.appId) : undefined,
    };
  },

  toJSON(message: OtpTarget): unknown {
    const obj: any = {};
    if (message.transferMethod !== 0) {
      obj.transferMethod = otpTransferMethodToJSON(message.transferMethod);
    }
    if (message.phoneNumber !== undefined) {
      obj.phoneNumber = message.phoneNumber;
    }
    if (message.emailAddress !== undefined) {
      obj.emailAddress = message.emailAddress;
    }
    if (message.appId !== undefined) {
      obj.appId = message.appId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<OtpTarget>, I>>(base?: I): OtpTarget {
    return OtpTarget.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<OtpTarget>, I>>(object: I): OtpTarget {
    const message = createBaseOtpTarget();
    message.transferMethod = object.transferMethod ?? 0;
    message.phoneNumber = object.phoneNumber ?? undefined;
    message.emailAddress = object.emailAddress ?? undefined;
    message.appId = object.appId ?? undefined;
    return message;
  },
};

function createBaseClientInformation(): ClientInformation {
  return {};
}

export const ClientInformation = {
  encode(_: ClientInformation, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): ClientInformation {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseClientInformation();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): ClientInformation {
    return {};
  },

  toJSON(_: ClientInformation): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<ClientInformation>, I>>(base?: I): ClientInformation {
    return ClientInformation.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ClientInformation>, I>>(_: I): ClientInformation {
    const message = createBaseClientInformation();
    return message;
  },
};

function createBasePage(): Page {
  return { page: 0, pageSize: 0, totalSize: 0 };
}

export const Page = {
  encode(message: Page, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.page !== 0) {
      writer.uint32(8).int32(message.page);
    }
    if (message.pageSize !== 0) {
      writer.uint32(16).int32(message.pageSize);
    }
    if (message.totalSize !== 0) {
      writer.uint32(24).int64(message.totalSize);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): Page {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.page = reader.int32();
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.pageSize = reader.int32();
          continue;
        case 3:
          if (tag !== 24) {
            break;
          }

          message.totalSize = longToNumber(reader.int64() as Long);
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Page {
    return {
      page: isSet(object.page) ? globalThis.Number(object.page) : 0,
      pageSize: isSet(object.pageSize) ? globalThis.Number(object.pageSize) : 0,
      totalSize: isSet(object.totalSize) ? globalThis.Number(object.totalSize) : 0,
    };
  },

  toJSON(message: Page): unknown {
    const obj: any = {};
    if (message.page !== 0) {
      obj.page = Math.round(message.page);
    }
    if (message.pageSize !== 0) {
      obj.pageSize = Math.round(message.pageSize);
    }
    if (message.totalSize !== 0) {
      obj.totalSize = Math.round(message.totalSize);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Page>, I>>(base?: I): Page {
    return Page.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Page>, I>>(object: I): Page {
    const message = createBasePage();
    message.page = object.page ?? 0;
    message.pageSize = object.pageSize ?? 0;
    message.totalSize = object.totalSize ?? 0;
    return message;
  },
};

function createBaseTimeContext(): TimeContext {
  return { clientTime: undefined, expectedArrivalTime: undefined, abortTime: undefined };
}

export const TimeContext = {
  encode(message: TimeContext, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.clientTime !== undefined) {
      Timestamp.encode(toTimestamp(message.clientTime), writer.uint32(10).fork()).ldelim();
    }
    if (message.expectedArrivalTime !== undefined) {
      Timestamp.encode(toTimestamp(message.expectedArrivalTime), writer.uint32(18).fork()).ldelim();
    }
    if (message.abortTime !== undefined) {
      Timestamp.encode(toTimestamp(message.abortTime), writer.uint32(26).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): TimeContext {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTimeContext();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.clientTime = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.expectedArrivalTime = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.abortTime = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TimeContext {
    return {
      clientTime: isSet(object.clientTime) ? fromJsonTimestamp(object.clientTime) : undefined,
      expectedArrivalTime: isSet(object.expectedArrivalTime)
        ? fromJsonTimestamp(object.expectedArrivalTime)
        : undefined,
      abortTime: isSet(object.abortTime) ? fromJsonTimestamp(object.abortTime) : undefined,
    };
  },

  toJSON(message: TimeContext): unknown {
    const obj: any = {};
    if (message.clientTime !== undefined) {
      obj.clientTime = message.clientTime.toISOString();
    }
    if (message.expectedArrivalTime !== undefined) {
      obj.expectedArrivalTime = message.expectedArrivalTime.toISOString();
    }
    if (message.abortTime !== undefined) {
      obj.abortTime = message.abortTime.toISOString();
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<TimeContext>, I>>(base?: I): TimeContext {
    return TimeContext.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TimeContext>, I>>(object: I): TimeContext {
    const message = createBaseTimeContext();
    message.clientTime = object.clientTime ?? undefined;
    message.expectedArrivalTime = object.expectedArrivalTime ?? undefined;
    message.abortTime = object.abortTime ?? undefined;
    return message;
  },
};

function createBaseRequestHeader(): RequestHeader {
  return { requestId: "", RequestHmac: new Uint8Array(0), timeContext: undefined };
}

export const RequestHeader = {
  encode(message: RequestHeader, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.requestId !== "") {
      writer.uint32(10).string(message.requestId);
    }
    if (message.RequestHmac.length !== 0) {
      writer.uint32(18).bytes(message.RequestHmac);
    }
    if (message.timeContext !== undefined) {
      TimeContext.encode(message.timeContext, writer.uint32(26).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): RequestHeader {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRequestHeader();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.requestId = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.RequestHmac = reader.bytes();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.timeContext = TimeContext.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RequestHeader {
    return {
      requestId: isSet(object.requestId) ? globalThis.String(object.requestId) : "",
      RequestHmac: isSet(object.RequestHmac) ? bytesFromBase64(object.RequestHmac) : new Uint8Array(0),
      timeContext: isSet(object.timeContext) ? TimeContext.fromJSON(object.timeContext) : undefined,
    };
  },

  toJSON(message: RequestHeader): unknown {
    const obj: any = {};
    if (message.requestId !== "") {
      obj.requestId = message.requestId;
    }
    if (message.RequestHmac.length !== 0) {
      obj.RequestHmac = base64FromBytes(message.RequestHmac);
    }
    if (message.timeContext !== undefined) {
      obj.timeContext = TimeContext.toJSON(message.timeContext);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<RequestHeader>, I>>(base?: I): RequestHeader {
    return RequestHeader.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RequestHeader>, I>>(object: I): RequestHeader {
    const message = createBaseRequestHeader();
    message.requestId = object.requestId ?? "";
    message.RequestHmac = object.RequestHmac ?? new Uint8Array(0);
    message.timeContext = (object.timeContext !== undefined && object.timeContext !== null)
      ? TimeContext.fromPartial(object.timeContext)
      : undefined;
    return message;
  },
};

function createBaseRequestContext(): RequestContext {
  return { requestHeader: undefined, appInfo: undefined, apiInfo: undefined, panelInfo: undefined, pwaInfo: undefined };
}

export const RequestContext = {
  encode(message: RequestContext, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.requestHeader !== undefined) {
      RequestHeader.encode(message.requestHeader, writer.uint32(10).fork()).ldelim();
    }
    if (message.appInfo !== undefined) {
      AppInfo.encode(message.appInfo, writer.uint32(18).fork()).ldelim();
    }
    if (message.apiInfo !== undefined) {
      APIInfo.encode(message.apiInfo, writer.uint32(26).fork()).ldelim();
    }
    if (message.panelInfo !== undefined) {
      PanelInfo.encode(message.panelInfo, writer.uint32(34).fork()).ldelim();
    }
    if (message.pwaInfo !== undefined) {
      PwaInfo.encode(message.pwaInfo, writer.uint32(42).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): RequestContext {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRequestContext();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.requestHeader = RequestHeader.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.appInfo = AppInfo.decode(reader, reader.uint32());
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.apiInfo = APIInfo.decode(reader, reader.uint32());
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.panelInfo = PanelInfo.decode(reader, reader.uint32());
          continue;
        case 5:
          if (tag !== 42) {
            break;
          }

          message.pwaInfo = PwaInfo.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RequestContext {
    return {
      requestHeader: isSet(object.requestHeader) ? RequestHeader.fromJSON(object.requestHeader) : undefined,
      appInfo: isSet(object.appInfo) ? AppInfo.fromJSON(object.appInfo) : undefined,
      apiInfo: isSet(object.apiInfo) ? APIInfo.fromJSON(object.apiInfo) : undefined,
      panelInfo: isSet(object.panelInfo) ? PanelInfo.fromJSON(object.panelInfo) : undefined,
      pwaInfo: isSet(object.pwaInfo) ? PwaInfo.fromJSON(object.pwaInfo) : undefined,
    };
  },

  toJSON(message: RequestContext): unknown {
    const obj: any = {};
    if (message.requestHeader !== undefined) {
      obj.requestHeader = RequestHeader.toJSON(message.requestHeader);
    }
    if (message.appInfo !== undefined) {
      obj.appInfo = AppInfo.toJSON(message.appInfo);
    }
    if (message.apiInfo !== undefined) {
      obj.apiInfo = APIInfo.toJSON(message.apiInfo);
    }
    if (message.panelInfo !== undefined) {
      obj.panelInfo = PanelInfo.toJSON(message.panelInfo);
    }
    if (message.pwaInfo !== undefined) {
      obj.pwaInfo = PwaInfo.toJSON(message.pwaInfo);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<RequestContext>, I>>(base?: I): RequestContext {
    return RequestContext.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RequestContext>, I>>(object: I): RequestContext {
    const message = createBaseRequestContext();
    message.requestHeader = (object.requestHeader !== undefined && object.requestHeader !== null)
      ? RequestHeader.fromPartial(object.requestHeader)
      : undefined;
    message.appInfo = (object.appInfo !== undefined && object.appInfo !== null)
      ? AppInfo.fromPartial(object.appInfo)
      : undefined;
    message.apiInfo = (object.apiInfo !== undefined && object.apiInfo !== null)
      ? APIInfo.fromPartial(object.apiInfo)
      : undefined;
    message.panelInfo = (object.panelInfo !== undefined && object.panelInfo !== null)
      ? PanelInfo.fromPartial(object.panelInfo)
      : undefined;
    message.pwaInfo = (object.pwaInfo !== undefined && object.pwaInfo !== null)
      ? PwaInfo.fromPartial(object.pwaInfo)
      : undefined;
    return message;
  },
};

function createBasePwaInfo(): PwaInfo {
  return { businessId: "", pwaSessionId: undefined, stepToken: "" };
}

export const PwaInfo = {
  encode(message: PwaInfo, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.businessId !== "") {
      writer.uint32(10).string(message.businessId);
    }
    if (message.pwaSessionId !== undefined) {
      StringValue.encode({ value: message.pwaSessionId! }, writer.uint32(18).fork()).ldelim();
    }
    if (message.stepToken !== "") {
      writer.uint32(26).string(message.stepToken);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): PwaInfo {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePwaInfo();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.businessId = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.pwaSessionId = StringValue.decode(reader, reader.uint32()).value;
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.stepToken = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PwaInfo {
    return {
      businessId: isSet(object.businessId) ? globalThis.String(object.businessId) : "",
      pwaSessionId: isSet(object.pwaSessionId) ? String(object.pwaSessionId) : undefined,
      stepToken: isSet(object.stepToken) ? globalThis.String(object.stepToken) : "",
    };
  },

  toJSON(message: PwaInfo): unknown {
    const obj: any = {};
    if (message.businessId !== "") {
      obj.businessId = message.businessId;
    }
    if (message.pwaSessionId !== undefined) {
      obj.pwaSessionId = message.pwaSessionId;
    }
    if (message.stepToken !== "") {
      obj.stepToken = message.stepToken;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PwaInfo>, I>>(base?: I): PwaInfo {
    return PwaInfo.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PwaInfo>, I>>(object: I): PwaInfo {
    const message = createBasePwaInfo();
    message.businessId = object.businessId ?? "";
    message.pwaSessionId = object.pwaSessionId ?? undefined;
    message.stepToken = object.stepToken ?? "";
    return message;
  },
};

function createBasePanelInfo(): PanelInfo {
  return { panelName: "", panelId: "", sessionToken: "" };
}

export const PanelInfo = {
  encode(message: PanelInfo, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.panelName !== "") {
      writer.uint32(10).string(message.panelName);
    }
    if (message.panelId !== "") {
      writer.uint32(18).string(message.panelId);
    }
    if (message.sessionToken !== "") {
      writer.uint32(26).string(message.sessionToken);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): PanelInfo {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePanelInfo();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.panelName = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.panelId = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.sessionToken = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PanelInfo {
    return {
      panelName: isSet(object.panelName) ? globalThis.String(object.panelName) : "",
      panelId: isSet(object.panelId) ? globalThis.String(object.panelId) : "",
      sessionToken: isSet(object.sessionToken) ? globalThis.String(object.sessionToken) : "",
    };
  },

  toJSON(message: PanelInfo): unknown {
    const obj: any = {};
    if (message.panelName !== "") {
      obj.panelName = message.panelName;
    }
    if (message.panelId !== "") {
      obj.panelId = message.panelId;
    }
    if (message.sessionToken !== "") {
      obj.sessionToken = message.sessionToken;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PanelInfo>, I>>(base?: I): PanelInfo {
    return PanelInfo.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PanelInfo>, I>>(object: I): PanelInfo {
    const message = createBasePanelInfo();
    message.panelName = object.panelName ?? "";
    message.panelId = object.panelId ?? "";
    message.sessionToken = object.sessionToken ?? "";
    return message;
  },
};

function createBaseAPIInfo(): APIInfo {
  return { businessId: "", businessToken: "", serviceType: 0, userSessionToken: "", stepToken: "" };
}

export const APIInfo = {
  encode(message: APIInfo, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.businessId !== "") {
      writer.uint32(10).string(message.businessId);
    }
    if (message.businessToken !== "") {
      writer.uint32(18).string(message.businessToken);
    }
    if (message.serviceType !== 0) {
      writer.uint32(24).int32(message.serviceType);
    }
    if (message.userSessionToken !== "") {
      writer.uint32(34).string(message.userSessionToken);
    }
    if (message.stepToken !== "") {
      writer.uint32(42).string(message.stepToken);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): APIInfo {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAPIInfo();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.businessId = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.businessToken = reader.string();
          continue;
        case 3:
          if (tag !== 24) {
            break;
          }

          message.serviceType = reader.int32() as any;
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.userSessionToken = reader.string();
          continue;
        case 5:
          if (tag !== 42) {
            break;
          }

          message.stepToken = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): APIInfo {
    return {
      businessId: isSet(object.businessId) ? globalThis.String(object.businessId) : "",
      businessToken: isSet(object.businessToken) ? globalThis.String(object.businessToken) : "",
      serviceType: isSet(object.serviceType) ? aPIServiceTypeFromJSON(object.serviceType) : 0,
      userSessionToken: isSet(object.userSessionToken) ? globalThis.String(object.userSessionToken) : "",
      stepToken: isSet(object.stepToken) ? globalThis.String(object.stepToken) : "",
    };
  },

  toJSON(message: APIInfo): unknown {
    const obj: any = {};
    if (message.businessId !== "") {
      obj.businessId = message.businessId;
    }
    if (message.businessToken !== "") {
      obj.businessToken = message.businessToken;
    }
    if (message.serviceType !== 0) {
      obj.serviceType = aPIServiceTypeToJSON(message.serviceType);
    }
    if (message.userSessionToken !== "") {
      obj.userSessionToken = message.userSessionToken;
    }
    if (message.stepToken !== "") {
      obj.stepToken = message.stepToken;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<APIInfo>, I>>(base?: I): APIInfo {
    return APIInfo.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<APIInfo>, I>>(object: I): APIInfo {
    const message = createBaseAPIInfo();
    message.businessId = object.businessId ?? "";
    message.businessToken = object.businessToken ?? "";
    message.serviceType = object.serviceType ?? 0;
    message.userSessionToken = object.userSessionToken ?? "";
    message.stepToken = object.stepToken ?? "";
    return message;
  },
};

function createBaseResponseContext(): ResponseContext {
  return { status: undefined, requestId: "", correlationId: "", nextStep: [], nextStepPage: 0, custom: {} };
}

export const ResponseContext = {
  encode(message: ResponseContext, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.status !== undefined) {
      Status.encode(message.status, writer.uint32(10).fork()).ldelim();
    }
    if (message.requestId !== "") {
      writer.uint32(18).string(message.requestId);
    }
    if (message.correlationId !== "") {
      writer.uint32(26).string(message.correlationId);
    }
    for (const v of message.nextStep) {
      NextStepInfo.encode(v!, writer.uint32(34).fork()).ldelim();
    }
    if (message.nextStepPage !== 0) {
      writer.uint32(56).int32(message.nextStepPage);
    }
    Object.entries(message.custom).forEach(([key, value]) => {
      ResponseContext_CustomEntry.encode({ key: key as any, value }, writer.uint32(250).fork()).ldelim();
    });
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): ResponseContext {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseResponseContext();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.status = Status.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.requestId = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.correlationId = reader.string();
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.nextStep.push(NextStepInfo.decode(reader, reader.uint32()));
          continue;
        case 7:
          if (tag !== 56) {
            break;
          }

          message.nextStepPage = reader.int32() as any;
          continue;
        case 31:
          if (tag !== 250) {
            break;
          }

          const entry31 = ResponseContext_CustomEntry.decode(reader, reader.uint32());
          if (entry31.value !== undefined) {
            message.custom[entry31.key] = entry31.value;
          }
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ResponseContext {
    return {
      status: isSet(object.status) ? Status.fromJSON(object.status) : undefined,
      requestId: isSet(object.requestId) ? globalThis.String(object.requestId) : "",
      correlationId: isSet(object.correlationId) ? globalThis.String(object.correlationId) : "",
      nextStep: globalThis.Array.isArray(object?.nextStep)
        ? object.nextStep.map((e: any) => NextStepInfo.fromJSON(e))
        : [],
      nextStepPage: isSet(object.nextStepPage) ? stepPagesFromJSON(object.nextStepPage) : 0,
      custom: isObject(object.custom)
        ? Object.entries(object.custom).reduce<{ [key: string]: string }>((acc, [key, value]) => {
          acc[key] = String(value);
          return acc;
        }, {})
        : {},
    };
  },

  toJSON(message: ResponseContext): unknown {
    const obj: any = {};
    if (message.status !== undefined) {
      obj.status = Status.toJSON(message.status);
    }
    if (message.requestId !== "") {
      obj.requestId = message.requestId;
    }
    if (message.correlationId !== "") {
      obj.correlationId = message.correlationId;
    }
    if (message.nextStep?.length) {
      obj.nextStep = message.nextStep.map((e) => NextStepInfo.toJSON(e));
    }
    if (message.nextStepPage !== 0) {
      obj.nextStepPage = stepPagesToJSON(message.nextStepPage);
    }
    if (message.custom) {
      const entries = Object.entries(message.custom);
      if (entries.length > 0) {
        obj.custom = {};
        entries.forEach(([k, v]) => {
          obj.custom[k] = v;
        });
      }
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ResponseContext>, I>>(base?: I): ResponseContext {
    return ResponseContext.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ResponseContext>, I>>(object: I): ResponseContext {
    const message = createBaseResponseContext();
    message.status = (object.status !== undefined && object.status !== null)
      ? Status.fromPartial(object.status)
      : undefined;
    message.requestId = object.requestId ?? "";
    message.correlationId = object.correlationId ?? "";
    message.nextStep = object.nextStep?.map((e) => NextStepInfo.fromPartial(e)) || [];
    message.nextStepPage = object.nextStepPage ?? 0;
    message.custom = Object.entries(object.custom ?? {}).reduce<{ [key: string]: string }>((acc, [key, value]) => {
      if (value !== undefined) {
        acc[key] = globalThis.String(value);
      }
      return acc;
    }, {});
    return message;
  },
};

function createBaseResponseContext_CustomEntry(): ResponseContext_CustomEntry {
  return { key: "", value: "" };
}

export const ResponseContext_CustomEntry = {
  encode(message: ResponseContext_CustomEntry, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== "") {
      writer.uint32(18).string(message.value);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): ResponseContext_CustomEntry {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseResponseContext_CustomEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.value = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ResponseContext_CustomEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? globalThis.String(object.value) : "",
    };
  },

  toJSON(message: ResponseContext_CustomEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== "") {
      obj.value = message.value;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ResponseContext_CustomEntry>, I>>(base?: I): ResponseContext_CustomEntry {
    return ResponseContext_CustomEntry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ResponseContext_CustomEntry>, I>>(object: I): ResponseContext_CustomEntry {
    const message = createBaseResponseContext_CustomEntry();
    message.key = object.key ?? "";
    message.value = object.value ?? "";
    return message;
  },
};

function createBaseNextStepInfo(): NextStepInfo {
  return { userAction: 0, navigationURI: "", nextStepToken: "", userSessionId: "", nextStepPage: 0 };
}

export const NextStepInfo = {
  encode(message: NextStepInfo, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.userAction !== 0) {
      writer.uint32(8).int32(message.userAction);
    }
    if (message.navigationURI !== "") {
      writer.uint32(18).string(message.navigationURI);
    }
    if (message.nextStepToken !== "") {
      writer.uint32(26).string(message.nextStepToken);
    }
    if (message.userSessionId !== "") {
      writer.uint32(34).string(message.userSessionId);
    }
    if (message.nextStepPage !== 0) {
      writer.uint32(40).int32(message.nextStepPage);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): NextStepInfo {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseNextStepInfo();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.userAction = reader.int32() as any;
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.navigationURI = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.nextStepToken = reader.string();
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.userSessionId = reader.string();
          continue;
        case 5:
          if (tag !== 40) {
            break;
          }

          message.nextStepPage = reader.int32() as any;
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): NextStepInfo {
    return {
      userAction: isSet(object.userAction) ? userFlowActionFromJSON(object.userAction) : 0,
      navigationURI: isSet(object.navigationURI) ? globalThis.String(object.navigationURI) : "",
      nextStepToken: isSet(object.nextStepToken) ? globalThis.String(object.nextStepToken) : "",
      userSessionId: isSet(object.userSessionId) ? globalThis.String(object.userSessionId) : "",
      nextStepPage: isSet(object.nextStepPage) ? stepPagesFromJSON(object.nextStepPage) : 0,
    };
  },

  toJSON(message: NextStepInfo): unknown {
    const obj: any = {};
    if (message.userAction !== 0) {
      obj.userAction = userFlowActionToJSON(message.userAction);
    }
    if (message.navigationURI !== "") {
      obj.navigationURI = message.navigationURI;
    }
    if (message.nextStepToken !== "") {
      obj.nextStepToken = message.nextStepToken;
    }
    if (message.userSessionId !== "") {
      obj.userSessionId = message.userSessionId;
    }
    if (message.nextStepPage !== 0) {
      obj.nextStepPage = stepPagesToJSON(message.nextStepPage);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<NextStepInfo>, I>>(base?: I): NextStepInfo {
    return NextStepInfo.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<NextStepInfo>, I>>(object: I): NextStepInfo {
    const message = createBaseNextStepInfo();
    message.userAction = object.userAction ?? 0;
    message.navigationURI = object.navigationURI ?? "";
    message.nextStepToken = object.nextStepToken ?? "";
    message.userSessionId = object.userSessionId ?? "";
    message.nextStepPage = object.nextStepPage ?? 0;
    return message;
  },
};

function createBaseBareResponse(): BareResponse {
  return { responseContext: undefined };
}

export const BareResponse = {
  encode(message: BareResponse, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.responseContext !== undefined) {
      ResponseContext.encode(message.responseContext, writer.uint32(10).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): BareResponse {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBareResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.responseContext = ResponseContext.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): BareResponse {
    return {
      responseContext: isSet(object.responseContext) ? ResponseContext.fromJSON(object.responseContext) : undefined,
    };
  },

  toJSON(message: BareResponse): unknown {
    const obj: any = {};
    if (message.responseContext !== undefined) {
      obj.responseContext = ResponseContext.toJSON(message.responseContext);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<BareResponse>, I>>(base?: I): BareResponse {
    return BareResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<BareResponse>, I>>(object: I): BareResponse {
    const message = createBaseBareResponse();
    message.responseContext = (object.responseContext !== undefined && object.responseContext !== null)
      ? ResponseContext.fromPartial(object.responseContext)
      : undefined;
    return message;
  },
};

function createBaseExceptionInfo(): ExceptionInfo {
  return { exceptionMassage: "", exceptionType: "" };
}

export const ExceptionInfo = {
  encode(message: ExceptionInfo, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.exceptionMassage !== "") {
      writer.uint32(10).string(message.exceptionMassage);
    }
    if (message.exceptionType !== "") {
      writer.uint32(18).string(message.exceptionType);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): ExceptionInfo {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseExceptionInfo();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.exceptionMassage = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.exceptionType = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ExceptionInfo {
    return {
      exceptionMassage: isSet(object.exceptionMassage) ? globalThis.String(object.exceptionMassage) : "",
      exceptionType: isSet(object.exceptionType) ? globalThis.String(object.exceptionType) : "",
    };
  },

  toJSON(message: ExceptionInfo): unknown {
    const obj: any = {};
    if (message.exceptionMassage !== "") {
      obj.exceptionMassage = message.exceptionMassage;
    }
    if (message.exceptionType !== "") {
      obj.exceptionType = message.exceptionType;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ExceptionInfo>, I>>(base?: I): ExceptionInfo {
    return ExceptionInfo.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ExceptionInfo>, I>>(object: I): ExceptionInfo {
    const message = createBaseExceptionInfo();
    message.exceptionMassage = object.exceptionMassage ?? "";
    message.exceptionType = object.exceptionType ?? "";
    return message;
  },
};

function bytesFromBase64(b64: string): Uint8Array {
  if ((globalThis as any).Buffer) {
    return Uint8Array.from(globalThis.Buffer.from(b64, "base64"));
  } else {
    const bin = globalThis.atob(b64);
    const arr = new Uint8Array(bin.length);
    for (let i = 0; i < bin.length; ++i) {
      arr[i] = bin.charCodeAt(i);
    }
    return arr;
  }
}

function base64FromBytes(arr: Uint8Array): string {
  if ((globalThis as any).Buffer) {
    return globalThis.Buffer.from(arr).toString("base64");
  } else {
    const bin: string[] = [];
    arr.forEach((byte) => {
      bin.push(globalThis.String.fromCharCode(byte));
    });
    return globalThis.btoa(bin.join(""));
  }
}

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function toTimestamp(date: Date): Timestamp {
  const seconds = Math.trunc(date.getTime() / 1_000);
  const nanos = (date.getTime() % 1_000) * 1_000_000;
  return { seconds, nanos };
}

function fromTimestamp(t: Timestamp): Date {
  let millis = (t.seconds || 0) * 1_000;
  millis += (t.nanos || 0) / 1_000_000;
  return new globalThis.Date(millis);
}

function fromJsonTimestamp(o: any): Date {
  if (o instanceof globalThis.Date) {
    return o;
  } else if (typeof o === "string") {
    return new globalThis.Date(o);
  } else {
    return fromTimestamp(Timestamp.fromJSON(o));
  }
}

function longToNumber(long: Long): number {
  if (long.gt(globalThis.Number.MAX_SAFE_INTEGER)) {
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  }
  if (long.lt(globalThis.Number.MIN_SAFE_INTEGER)) {
    throw new globalThis.Error("Value is smaller than Number.MIN_SAFE_INTEGER");
  }
  return long.toNumber();
}

if (_m0.util.Long !== Long) {
  _m0.util.Long = Long as any;
  _m0.configure();
}

function isObject(value: any): boolean {
  return typeof value === "object" && value !== null;
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
